import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import Reducer from "./rootReducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const config = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(config, Reducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));

const persistor = persistStore(store);

export { store, persistor };
